<template>
  <div
    class="w-full px-4 py-2 flex tablet-h:rounded-[10px] tablet-h:p-1.5 tablet-h:pr-2.5"
    :class="classes"
  >
    <div class="mr-[9px] size-11 shrink-0 p-0.5">
      <DacrMarkIcon class="size-full text-gray-800" />
    </div>
    <div
      class="text-[14px] leading-[19px] text-gray-800 -mt-1 flex flex-col justify-between"
    >
      <div class="mb-[3px]">
        Copyright all your original work and IP with Dacr! Easily get started by
        adding your files today.
      </div>
      <div class="text-[12px] leading-[18px] opacity-60">
        {{ formatDistanceToNowStrict(props.notification.timestamp) }} ago
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Notification } from '@/shared/graphql/legacy/generated'
import { DacrMarkIcon } from '@dacr/icons'
import { formatDistanceToNowStrict } from 'date-fns'
import { computed } from 'vue'

const props = defineProps<{
  notification: Notification
}>()

const classes = computed(() => ({
  'tablet-h:hover:bg-[#FAFAFA]': props.notification.read,
  'bg-green-700/10': !props.notification.read,
}))
</script>
